module.exports = __webpack_public_path__ + "static/garageDoorsB-941c32e2c45821b608dd4acf8a286c86.jpg";